import { SvgIcon, type SvgIconProps } from '@mui/material'

export function ChangeColumnIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox='0 0 18 18' {...props}>
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M14.25 2.25H3.75c-.825 0-1.5.675-1.5 1.5v10.5c0 .825.675 1.5 1.5 1.5h10.5c.825 0 1.5-.675 1.5-1.5V3.75c0-.825-.675-1.5-1.5-1.5m-3.75 12h-3V3.75h3zM3.75 3.75H6v10.5H3.75zM12 14.25V3.75h2.25v10.5z'
        clipRule='evenodd'
      />
    </SvgIcon>
  )
}
